import { render, staticRenderFns } from "./RdTripStatusSwitcher.vue?vue&type=template&id=48456543&scoped=true&"
import script from "./RdTripStatusSwitcher.vue?vue&type=script&lang=ts&"
export * from "./RdTripStatusSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48456543",
  null
  
)

export default component.exports